import React, { createContext, useContext } from 'react';
import { useInfo } from '@/hooks';

interface InfoContextType {
  globalInfo: ReturnType<typeof useInfo>;
}

const InfoContext = createContext<InfoContextType | null>(null);

export const InfoProvider = ({ children }: { children: React.ReactNode }) => {
  const globalInfo = useInfo();

  return (
    <InfoContext.Provider
      value={{
        globalInfo,
      }}
    >
      {children}
    </InfoContext.Provider>
  );
};

export const useInfoContext = () => {
  const context = useContext(InfoContext);
  if (!context) {
    throw new Error('useInfoContext must be used within an InfoProvider');
  }
  return context;
};
